<div class="legend-container">
    <div class="legends" *ngFor="let legend of legendColorArray">
        <div [ngSwitch]="legend.type">
            <p *ngSwitchCase="'line'">
                <span [ngStyle]="{borderTop: '2px solid', borderColor: legend.color}"></span>
                {{ legend.name }}
            </p>
            <p *ngSwitchCase="'dashed'">
                <span [ngStyle]="{borderTop: '3px dotted', borderColor: legend.color}"></span>
                {{ legend.name }}
            </p>
            <p *ngSwitchCase="'circle'">
                <span class="circle" [ngStyle]="{backgroundColor: legend.color}"></span>
                {{ legend.name }}
            </p>
            <p *ngSwitchCase="'triangle'">
                <span class="textSymbol" [ngStyle]="{color: legend.color}">&#9660;</span>
                {{ legend.name }}
            </p>
            <p *ngSwitchCase="'star'">
                <span class="textSymbol" [ngStyle]="{color: legend.color}">&#10041;</span>
                {{ legend.name }}
            </p>
            <p *ngSwitchCase="'diamond'">
                <span class="diamond" [ngStyle]="{backgroundColor: legend.color}"></span>
                {{ legend.name }}
            </p>
            <p *ngSwitchCase="'square'">
                <span class="square" [ngStyle]="{backgroundColor: legend.color}"></span>
                {{ legend.name }}
            </p>
            <p *ngSwitchCase="'default'">
                <span class="default" [ngStyle]="{backgroundColor: legend.color}"></span>
                {{ legend.name }}
            </p>
        </div>
    </div>
</div>
